import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import PhoneInput from 'react-phone-input-2';
import PropTypes from 'prop-types';

import 'react-phone-input-2/lib/style.css';

const useStyles = makeStyles((theme) => ({
  paperFullWidth: {
    overflowY: 'visible',
  },
  dialogContentRoot: {
    overflowY: 'visible',
  },
  dialogAction: {
    margin: theme.spacing(1, 1),
  },
}));

const CredentialAdd = ({ visible, dismiss, requestCredential, cardholderId }) => {
  const classes = useStyles();
  const [phone, setPhone] = React.useState('');

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={visible}
      onClose={() => dismiss()}
      classes={{ paperFullWidth: classes.paperFullWidth }}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Request a mobile credential</DialogTitle>
      <DialogContent classes={{ root: classes.dialogContentRoot }}>
        <Typography>Phone number</Typography>
        <PhoneInput
          country="us"
          onlyCountries={['us', 'ca']}
          value={phone}
          onChange={(newPhone) => setPhone(newPhone)}
          inputProps={{ autoFocus: true }}
        />
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button onClick={() => dismiss()}>Cancel</Button>
        <Button
          color="secondary"
          variant="contained"
          onClick={() => {
            requestCredential({
              variables: { cardholderId, phoneNumber: phone },
            });
            dismiss();
          }}
        >
          Request
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CredentialAdd.propTypes = {
  visible: PropTypes.bool.isRequired,
  dismiss: PropTypes.func.isRequired,
  requestCredential: PropTypes.func.isRequired,
  cardholderId: PropTypes.number.isRequired,
};

export default CredentialAdd;
